/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { DaumPost } from "src/components/shared/models";
import { useAppDispatch, useAppSelector } from "src/store";
import { getInterneObjave, updatePostHash } from "src/store/objave-store";
import moment from "moment";
import NoImage from "../../assets/no-image.jpg";

function InterneObjave() {
  const { hash } = useParams();
  const { interneObjave } = useAppSelector((state) => state.post);
  const dispatch = useAppDispatch();

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredPosts, setFilteredPosts] = useState<DaumPost[]>([]);

  useEffect(() => {
    const getAllPosts = async () => {
      dispatch(getInterneObjave({ page: 1, per_page: 1000, hash }));
      dispatch(updatePostHash(hash));
    };

    getAllPosts();
  }, []);

  useEffect(() => {
    if (interneObjave && interneObjave.data) {
      const filtered = interneObjave.data.filter((item: DaumPost) => {
        const normalizedTitle = item.title
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase();
        const normalizedSearchTerm = searchTerm
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase();

        return normalizedTitle.includes(normalizedSearchTerm);
      });
      setFilteredPosts(filtered);
    }
  }, [searchTerm, interneObjave]);

  const getPostsByCategoryName = (categoryName: string) =>
    filteredPosts.filter((post) => post.categories?.some((category: any) => category.name === categoryName));

  const getOtherPosts = () =>
    filteredPosts.filter(
      (post) => !post.categories?.some((category: any) => category.name === "PPCG" || category.name === "PUP")
    );
  const renderPosts = (posts: DaumPost[]) =>
    posts.map((item: DaumPost, index: number) => (
      <Link
        key={index}
        to={`/interne-objave/${hash}/${item.id}`}
        className="bg-white rounded-lg overflow-hidden m-0 p-0 block form-control group !hover:bg-opacity-100"
      >
        {/* Slika */}
        <div className="w-full" style={{ height: "200px" }}>
          {" "}
          {/* Fiksna visina slike */}
          {item.image && item.image.file_url ? (
            <img
              src={item.image.file_url}
              alt={item.title}
              className="w-full h-full object-cover transition-opacity duration-300 group-hover:opacity-75"
            />
          ) : (
            <img
              src={NoImage}
              alt="No image"
              className="w-full h-full object-cover transition-opacity duration-300 group-hover:opacity-75"
            />
          )}
        </div>

        <div className="p-3">
          <h2 className="text-lg font-semibold text-gray-800 group-hover:text-gray-600">{item.title}</h2>
        </div>
      </Link>
    ));

  return (
    <div className="m-0 p-0 mt-10 pb-1">
      <div className="mb-[50px]">
        <input
          type="text"
          className="form-control p-[10px] !text-lg rounded-lg"
          placeholder="Pretraži planove po naslovu..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {getPostsByCategoryName("PPCG").length > 0 && (
        <div className="category-section">
          <h3 className="category-title mb-4">Prostorni plan Crne Gore</h3>
          <div className="w-full">
            {getPostsByCategoryName("PPCG")
              .slice(0, 1)
              .map((item: DaumPost, index: number) => (
                <Link
                  key={index}
                  to={`/interne-objave/${hash}/${item.id}`}
                  className="bg-white rounded-lg overflow-hidden block form-control p-0 transition group"
                >
                  {/* Slika */}
                  <div className="w-full md:h-[400px] h-[200px]">
                    {" "}
                    {item.image && item.image.file_url ? (
                      <img
                        src={item.image.file_url}
                        alt={item.title}
                        className="w-full h-full object-cover transition-opacity duration-300 group-hover:opacity-75"
                      />
                    ) : (
                      <img
                        src={NoImage}
                        alt="No image"
                        className="w-full h-full object-cover transition-opacity duration-300 group-hover:opacity-75"
                      />
                    )}
                  </div>

                  {/* Naslov */}
                  <div className="p-6">
                    <h2 className="text-2xl font-semibold text-gray-800 group-hover:text-gray-600">{item.title}</h2>
                  </div>
                </Link>
              ))}
          </div>
        </div>
      )}

      {/* Sekcija PUP */}
      {getPostsByCategoryName("PUP").length > 0 && (
        <div className="category-section">
          <h3 className="category-title mb-4">Prostorno urbanistički planovi</h3>
          <div className="interneObjavaGrid">{renderPosts(getPostsByCategoryName("PUP"))}</div>
        </div>
      )}

      {/* Sekcija ostale kategorije */}
      {getOtherPosts().length > 0 && (
        <div className="category-section">
          <h3 className="category-title mb-4">DSL - DUP - UP</h3>
          <div className="interneObjavaGrid">{renderPosts(getOtherPosts())}</div>
        </div>
      )}
    </div>
  );
}

export default InterneObjave;
